(function () {
  'use strict';

  var TOOLTIP_ID = 'mw-review-tooltip';
  var STYLES_ID = 'mw-review-tooltip-css';

  /* ── Junip lazy-load cache ───────────────────────────────────────
   * Junip's review section loads on scroll, so these values may not
   * be in the DOM when the tooltip opens. We observe and cache them
   * as soon as they appear so the tooltip always has the right data.
   * ---------------------------------------------------------------- */
  var _cachedAiSummary = null; // null = not yet seen
  var _cachedDist = null;

  function getStarContainer(target) {
    return (
      target &&
      target.closest &&
      target.closest('.junip-product-summary-star-ratings-container')
    );
  }

  /* ── Styles ──────────────────────────────────────────────────────── */

  var CSS = [
    '#mw-review-tooltip {',
    '  position: absolute;',
    '  z-index: 9999;',
    '  background: #fff;',
    '  border: 1px solid rgba(0,18,55,0.12);',
    '  border-radius: 4px;',
    '  box-shadow: 0 4px 20px rgba(0,18,55,0.14);',
    '  width: 260px;',
    '  padding: 16px;',
    '  font-size: 13px;',
    '  color: #001237;',
    '  line-height: 1.4;',
    '}',
    '#mw-review-tooltip[hidden] { display: none !important; }',
    '.mw-rt__header {',
    '  display: flex;',
    '  align-items: baseline;',
    '  gap: 8px;',
    '  margin-bottom: 12px;',
    '}',
    '.mw-rt__avg {',
    '  font-size: 22px;',
    '  font-weight: 700;',
    '  letter-spacing: -0.5px;',
    '}',
    '.mw-rt__avg-star { color: #001237; font-size: 20px; line-height: 1; }',
    '.mw-rt__count { font-size: 12px; opacity: 0.55; }',
    '.mw-rt__dist { margin-bottom: 12px; }',
    '.mw-rt__dist-row {',
    '  display: flex;',
    '  align-items: center;',
    '  gap: 6px;',
    '  font-size: 11px;',
    '  margin-bottom: 3px;',
    '}',
    '.mw-rt__dist-label { display: flex; align-items: center; gap: 3px; flex-shrink: 0; }',
    '.mw-rt__dist-star { color: #001237; font-size: 9px; line-height: 1; }',
    '.mw-rt__dist-num { font-size: 11px; opacity: 0.6; }',
    '.mw-rt__dist-track {',
    '  flex: 1;',
    '  height: 5px;',
    '  background: rgba(0,18,55,0.07);',
    '  border-radius: 99px;',
    '  overflow: hidden;',
    '}',
    '.mw-rt__dist-fill { height: 100%; background: #1c9aff; border-radius: 99px; }',
    '.mw-rt__dist-count { width: 20px; text-align: right; opacity: 0.55; flex-shrink: 0; font-size: 10px; }',
    '.mw-rt__summary {',
    '  font-size: 12px;',
    '  line-height: 1.55;',
    '  margin: 0 0 12px;',
    '  padding-top: 12px;',
    '  border-top: 1px solid rgba(0,18,55,0.08);',
    '  opacity: 0.8;',
    '}',
    '.mw-rt__cta {',
    '  display: inline-block;',
    '  font-size: 12px;',
    '  font-weight: 600;',
    '  color: #001237;',
    '  background: none;',
    '  border: none;',
    '  padding: 0;',
    '  cursor: pointer;',
    '  text-decoration: none;',
    '}',
    '.mw-rt__cta:hover { opacity: 0.65; }',
    '.mw-rt__cta-text { text-decoration: underline; text-underline-offset: 2px; }',
    '@media (max-width: 1279px) {',
    '  .productInfo__price.body-2 { font-size: 16px; line-height: 21px; }',
    '  .junip-product-summary-review-count { font-size: 16px !important; line-height: 21px !important; }',
    '}',
    '.productInfo__priceRow { display: flex; align-items: baseline; flex-wrap: wrap; }',
    '.productInfo__ratingsWithSep { display: flex; align-items: center; }',
    '.productInfo__priceSep { margin: 0 10px; opacity: 0.25; font-size: 16px; line-height: 1; user-select: none; }',
    '.junip-product-summary { cursor: default !important; }',
    '.junip-product-summary-star-ratings-container { cursor: pointer; }',
    '.junip-product-summary:focus,',
    '.junip-product-summary *:focus,',
    '.junip-product-summary:focus-visible,',
    '.junip-product-summary *:focus-visible { outline: none !important; box-shadow: none !important; }',
  ].join('\n');

  function injectStyles() {
    if (document.getElementById(STYLES_ID)) return;
    var style = document.createElement('style');
    style.id = STYLES_ID;
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  /* ── Histogram ───────────────────────────────────────────────────── */

  // Junip's bar widget structure (in the review section):
  //   .junip-product-review-bar-wrapper[aria-label="5 stars, 11,478 reviews. ..."]
  //     .junip-product-review-bar-rating  → "5"
  //     .junip-product-review-bar
  //       .junip-product-review-bar-filled[style="width: 77%; ..."]
  function getDistribution() {
    var wrappers = document.querySelectorAll(
      '.junip-product-review-bar-wrapper'
    );
    if (!wrappers.length) return null;

    var dist = [];
    wrappers.forEach(function (wrapper) {
      var ratingEl = wrapper.querySelector('.junip-product-review-bar-rating');
      var fillEl = wrapper.querySelector('.junip-product-review-bar-filled');
      var label = wrapper.getAttribute('aria-label') || '';
      var countMatch = label.match(/([\d,]+) reviews?/i);

      if (ratingEl && fillEl) {
        dist.push({
          stars: ratingEl.textContent.trim(),
          width: fillEl.style.width || '0%',
          count: countMatch ? countMatch[1] : '',
        });
      }
    });
    if (dist.length) _cachedDist = dist;
    return dist.length ? dist : null;
  }

  /* ── Junip AI summary ───────────────────────────────────────────── */

  function getAiSummary() {
    if (_cachedAiSummary !== null) return _cachedAiSummary;
    var el = document.querySelector('.junip-ai-summary-text');
    return el ? el.textContent.trim() : '';
  }

  /* ── Tooltip content ─────────────────────────────────────────────── */

  function buildContent(summaryEl) {
    var summary = getAiSummary();
    var avg = parseFloat(
      summaryEl ? summaryEl.dataset.productRatingAverage : 0
    ).toFixed(2);
    var cnt = parseInt(
      summaryEl ? summaryEl.dataset.productRatingCount : 0,
      10
    ).toLocaleString();
    var dist = getDistribution();

    var html =
      '<div class="mw-rt__header">' +
      '<span class="mw-rt__avg">' +
      avg +
      '</span>' +
      '<span class="mw-rt__avg-star">★</span>' +
      '<span class="mw-rt__count">' +
      cnt +
      ' reviews</span>' +
      '</div>';

    if (dist && dist.length) {
      html += '<div class="mw-rt__dist">';
      dist.forEach(function (row) {
        html +=
          '<div class="mw-rt__dist-row">' +
          '<span class="mw-rt__dist-label"><span class="mw-rt__dist-num">' +
          row.stars +
          '</span><span class="mw-rt__dist-star">★</span></span>' +
          '<div class="mw-rt__dist-track">' +
          '<div class="mw-rt__dist-fill" style="width:' +
          row.width +
          '"></div>' +
          '</div>' +
          '</div>';
      });
      html += '</div>';
    }

    if (summary) {
      html += '<p class="mw-rt__summary">' + summary + '</p>';
    }

    html +=
      '<button class="mw-rt__cta" type="button"><span class="mw-rt__cta-text">Read all reviews</span> \u2193</button>';

    return html;
  }

  /* ── Tooltip show/hide ───────────────────────────────────────────── */

  function ensureTooltip() {
    var t = document.getElementById(TOOLTIP_ID);
    if (!t) {
      t = document.createElement('div');
      t.id = TOOLTIP_ID;
      t.setAttribute('role', 'dialog');
      t.setAttribute('aria-label', 'Review rating summary');
      t.setAttribute('hidden', '');
      document.body.appendChild(t);

      t.addEventListener('click', function (e) {
        if (e.target.closest('.mw-rt__cta')) {
          closeTooltip(t);
          var target = document.querySelector(
            '.junip-review-section, #junip-reviews, .junip-product-review, [id^="junipProductReviews"]'
          );
          if (target)
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
    return t;
  }

  function positionTooltip(tooltip, anchor) {
    var rect = anchor.getBoundingClientRect();
    var sY = window.pageYOffset || document.documentElement.scrollTop;
    var sX = window.pageXOffset || document.documentElement.scrollLeft;
    tooltip.style.top = rect.bottom + sY + 8 + 'px';
    tooltip.style.left = rect.left + sX + 'px';
    requestAnimationFrame(function () {
      var tr = tooltip.getBoundingClientRect();
      if (tr.right > window.innerWidth - 12) {
        tooltip.style.left =
          Math.max(8, window.innerWidth - tr.width - 12) + sX + 'px';
      }
    });
  }

  function openTooltip(tooltip, summaryEl) {
    tooltip.innerHTML = buildContent(summaryEl);
    tooltip.removeAttribute('hidden');
    positionTooltip(tooltip, summaryEl);
  }

  function closeTooltip(tooltip) {
    tooltip.setAttribute('hidden', '');
  }

  /* ── Click handler (document-level, no DOM dependency) ───────────── */

  document.addEventListener(
    'click',
    function (e) {
      // Swallow all clicks within .junip-product-summary so Junip never scrolls
      var summary =
        e.target.closest && e.target.closest('.junip-product-summary');
      if (!summary) return;
      e.stopImmediatePropagation();

      // Only open/close the tooltip for clicks on the star ratings container
      if (!getStarContainer(e.target)) return;

      var tooltip = ensureTooltip();
      if (tooltip.hasAttribute('hidden')) {
        openTooltip(tooltip, summary);
      } else {
        closeTooltip(tooltip);
      }
    },
    true
  ); // capture — fires before Junip's bubble handlers

  // Close on outside click
  document.addEventListener('click', function (e) {
    var tooltip = document.getElementById(TOOLTIP_ID);
    if (!tooltip || tooltip.hasAttribute('hidden')) return;
    if (tooltip.contains(e.target)) return;
    closeTooltip(tooltip);
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var tooltip = document.getElementById(TOOLTIP_ID);
    if (tooltip) closeTooltip(tooltip);
  });

  /* ── Init ────────────────────────────────────────────────────────── */

  // Watch for Junip's review section to lazy-load and pre-populate cache
  (function () {
    var obs = new MutationObserver(function () {
      if (_cachedAiSummary === null) {
        var el = document.querySelector('.junip-ai-summary-text');
        if (el && el.textContent.trim())
          _cachedAiSummary = el.textContent.trim();
      }
      if (!_cachedDist) getDistribution(); // caches internally on first successful read
    });
    obs.observe(document.body, { childList: true, subtree: true });
  })();

  injectStyles();
})();
